import { createContext } from 'react';

import { useMediaQuery } from '@react-hook/media-query';

import { BreakpointTypes, responsiveMap } from '@utils/theme/breakPoint';

export type ScreenMap = Partial<Record<BreakpointTypes, boolean>>;

export const BreakpointsContext = createContext<ScreenMap>({});

/**
 * BreakpointsProvider
 * @description
 * This provider is used to provide the current screen size to the application
 */
const BreakpointsProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <BreakpointsContext.Provider
      value={{
        xs: useMediaQuery(`only screen and ${responsiveMap.xs}`),
        sm: useMediaQuery(`only screen and ${responsiveMap.sm}`),
        md: useMediaQuery(`only screen and ${responsiveMap.md}`),
        lg: useMediaQuery(`only screen and ${responsiveMap.lg}`),
        xl: useMediaQuery(`only screen and ${responsiveMap.xl}`),
        xxl: useMediaQuery(`only screen and ${responsiveMap.xxl}`),
      }}
    >
      {children}
    </BreakpointsContext.Provider>
  );
};

export default BreakpointsProvider;
